// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ajustes[data-v-d8c13ffc] {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border: 1px solid #faebcc;\n  border-radius: 4px;\n  overflow-wrap: anywhere;\n}", ""]);
// Exports
module.exports = exports;
